import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useRequest } from 'hooks';

import { DOCUMENT_TYPES } from 'utils/Constants';

import { Title } from 'components/Misc/Typography';
import { Form, Input, Select, Button, Checkbox } from 'components/Misc/Form';

import Grades from 'containers/Administrator/Documents/Create/Grades';
import Courses from 'containers/Administrator/Documents/Create/Courses';

import { useDocumentCreateStore } from 'store/document/useDocumentCreateStore';

const Create = () => {
	// Use router's history
	const history = useHistory();

	// Use document's creation store
	const [document, onChange, onReset] = useDocumentCreateStore(state => [
		state.document,
		state.onChange,
		state.onReset
	]);

	// Store request
	const [[progress], request] = useRequest('post', 'documents');

	// Handle store cleanup
	useEffect(() => {
		return () => onReset();
	}, []);

	// Handle submit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// Do not submit if request in progress
		if (progress) return;

		// Try to create document
		const [success, error] = await request(document);

		// Redirect on successful creation
		if (success) return history.push('/documents');

		// TODO: Handle errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="p-4 mx-auto max-w-screen-md space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Pamatinformācija"
				className="md:col-span-2 text-xl"
			/>

			<Input
				type="text"
				name="title"
				label="Virsraksts"
				value={document.title}
				onChange={onChange}
				className="md:col-span-2"
			/>

			<div className="grid md:grid-cols-2 gap-4">
				<Select
					name="type"
					label="Kategorija"
					placeholder=" "
					value={document.type}
					onChange={onChange}
					options={DOCUMENT_TYPES.map(type => ({
						value: type.value, name: type.text
					}))}
				/>
			</div>

			<Title title="Grupas" className="text-xl" />

			{/* Document's groups */}
			<div className="flex space-x-4">
				<Checkbox
					small
					inline
					name="teacher"
					label="Pedagogi"
					value={document.teacher}
					onChange={onChange}
				/>

				<Checkbox
					small
					inline
					name="student"
					label="Studenti"
					value={document.student}
					onChange={onChange}
				/>

				<Checkbox
					small
					inline
					name="parent"
					label="Vecāki"
					value={document.parent}
					onChange={onChange}
				/>
			</div>

			{/* Document's grades */}
			<Grades />

			{/* Document's courses */}
			<Courses />

			<div className="flex justify-end">
				<Button
					submit
					icon="done"
					value="Izveidot"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Create;
